import styled from 'styled-components';
interface ISearchBarProps {
  $visible: boolean;
}
export const Container = styled.div<ISearchBarProps>`
  display: flex;
  flex-direction: column;
  .scroll {
    height: ${props =>
      props.$visible ? 'calc(100vh - 226px)' : 'calc(100vh - 168px)'};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: baseline;
  > div {
    display: flex;
    align-items: center;
  }
  /* h4 {
    margin-bottom: 1rem;
    margin-left: 15px;
  } */
`;
export const SearchBar = styled.div<ISearchBarProps>`
  opacity: ${props => (props.$visible ? 1 : 0)};
  max-height: ${props => (props.$visible ? '100px' : '0')};
  overflow: hidden;
  transition: ${props =>
    props.$visible
      ? 'opacity 2s ease, max-height 1s ease'
      : 'opacity 0.5s ease, max-height 1s ease'};
`;

export const Avaliacoes = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  > div {
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        margin-top: 4px;
      }
    }
  }
`;
export const Dados = styled.div`
  cursor: copy;
  display: grid;
  grid-template-columns: 1fr 1fr;
  text-overflow: ellipsis;
  > div {
    overflow: hidden;
    .subcategoria {
      display: flex;
      align-items: center;
    }
    p {
      padding: 0.1rem 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
`;
export const THead = styled.thead`
  tr {
    white-space: nowrap;
    th {
      padding: 0.5rem;
      &:first-of-type {
        padding-left: 1rem;
      }
      &:nth-of-type(3) {
        align-items: center;
        bottom: -2px;
        position: relative;
        display: flex;
        justify-content: center;
        width: 31rem;
        button {
          margin: 0;
        }
      }
    }
  }
`;

export const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  button {
    width: 45px;
    margin: 0 auto !important;
  }
`;
export const Thumbnail = styled.div`
  padding: 0 1rem;
`;

export const Comunicacao = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  h5 {
    margin: 1rem 0 0.5rem 0;
    border-bottom: 1px solid;
  }
  > div {
    padding: 1rem;
  }
`;

export const AvaliacaoHelp = styled.table`
  color: ${props => props.theme.fontColor};
  border: 1px solid ${props => props.theme.fontColor};
  border-collapse: collapse;
  th,
  td {
    white-space: nowrap;
    border: 1px solid ${props => props.theme.fontColor};
    border-collapse: collapse;
    padding: 0.2rem 0.5rem;
  }
`;
